let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2ksh5")).then(() => parcelRequire('3BDe4'));